import styled from "styled-components/macro";

export const Wrapper = styled.fieldset`
    margin: 0;
    padding: 0;
    border: 0;

    &:not(:first-child) {
    }

    &:not(:last-child) {
    }
`;
